module.exports = "<li class=wh-blog-listing-results-item> <a href=\"<%= data.Link %>\"> <h3 class=wh-blog-listing-results-item__title> <%= data.Title %> </h3> <span class=wh-blog-listing-results-item__date><%= data.Date %></span> </a> <div class=wh-blog-listing-results-item__description> <%= data.Description %> </div> </li> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/templates/blog-listing-item.html
// module id = 610
// module chunks = 64